module.exports = __webpack_public_path__ + "mada-v7-latin-600.woff";